import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authInterceptorProviders } from '@core/interceptors/auth.interceptor';
import { LoginComponent } from '@modules/public/login/login.component';
import { HOME_VIDEO, LOGIN, MAIN } from '@core/constants/RoutingsPath';

const routes: Routes = [
  {
    path: LOGIN,
    component: LoginComponent,
    title: 'page.login'
  },
  {
    path: MAIN,
    loadChildren: () => import('./modules/main.module').then((m) => m.MainModule)
  },
  {
    path: '**',
    redirectTo: HOME_VIDEO,
    pathMatch: 'full',
    title: 'page.intro'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    })
  ],
  exports: [RouterModule],
  providers: [authInterceptorProviders]
})
export class AppRoutingModule {}
